import React from 'react';
import styled from 'styled-components';

const Landing = styled.div`
  display: inline-block;
  width: 100%;

  img {
    height: auto;
    width: 100%;
  }

  @media (min-width: 480px) {
    padding-top: 200px;
    width: 50%;
  }
`;

const LandingGallery = () => { return (
    <Landing className="landing__photos">
      <img src={ require('./largeplaza.jpg') } alt="Landing plaza" />
    </Landing>)
};


export default LandingGallery



// WEBPACK FOOTER //
// ./src/components/LandingGallery/index.js